var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c("hosting-password", {
            attrs: {
              hostingid: _vm.hostingid,
              title: "Change Password for Reseller Hosting Plan:"
            },
            scopedSlots: _vm._u([
              {
                key: "before-password",
                fn: function fn() {
                  return [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "mb-0"
                          },
                          [
                            _vm._v(
                              "This will change the password for your main reseller hosting "
                            ),
                            _c("b", [_vm._v(_vm._s(_vm.hosting.domain))]),
                            _vm._v(" only. ")
                          ]
                        )
                      ]
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }